(() => {
  const guide = document.querySelector('[data-guide-topic="solid-lip-balm"]');
  if (!guide) return;
  const box = guide.querySelector('[data-lip-search]');
  const items = [...guide.querySelectorAll('[data-lip-faq]')];
  const normal = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l').replace(/Ł/g, 'l').toLocaleLowerCase();
  if (box && items.length) {
    const input = box.querySelector('[data-lip-query]');
    const count = box.querySelector('[data-lip-count]');
    const texts = items.map(item => normal(item.textContent));
    const update = () => {
      const words = normal(input.value).trim().split(/\s+/).filter(Boolean);
      let found = 0;
      items.forEach((item, i) => { item.hidden = !words.every(word => texts[i].includes(word)); if (!item.hidden) found++; });
      count.textContent = count.dataset.template.replace('{n}', found).replace('{total}', items.length);
      box.querySelector('[data-lip-empty]').hidden = found !== 0;
    };
    input.addEventListener('input', update);
    box.querySelector('[data-lip-reset]').addEventListener('click', () => { input.value = ''; update(); input.focus(); });
    const revealAnchor = () => {
      const target = document.getElementById(location.hash.slice(1));
      if (target?.closest('[data-lip-faq]')?.hidden) { input.value = ''; update(); target.scrollIntoView(); }
    };
    window.addEventListener('hashchange', revealAnchor);
    box.hidden = false;
    update();
    revealAnchor();
  }
  const print = guide.querySelector('[data-lip-print]');
  if (print) { print.hidden = false; print.addEventListener('click', () => window.print()); }
})();
